import React from 'react';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {ScrollBorder} from '@netx/core-components/ScrollBorder';
import {SettingsPaneRow} from './SettingsPaneRow';
import {
	settingsPaneClasses,
	getSettingsPaneUtilityClass,
	SettingsPaneClasses,
	SETTINGS_PANE_CLASS_NAME,
} from './settingsPaneClasses';
import clsx from 'clsx';

type SettingsPaneOwnerState = WithClasses<SettingsPaneClasses>;

const useUtilityClasses = (ownerState: SettingsPaneOwnerState) => {
	const {classes} = ownerState;

	const slots = {
		root: ['root'],
		row: ['row'],
	};

	return composeClasses(slots, getSettingsPaneUtilityClass, classes);
};

const SettingsPaneRoot = styled(ScrollBorder, {
	name: SETTINGS_PANE_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	display: 'flex',
	flexDirection: 'column',
	flex: '1 1 auto',
	position: 'relative',
}));

export type SettingsPaneProps = WithClasses<
	SettingsPaneClasses,
	{
		children: [React.ReactNode, React.ReactNode][];
	}
>;

export const SettingsPanePrimitive = ({
	classes: _classes,
	className,
	children,
}: SettingsPaneProps) => {
	const ownerState: SettingsPaneOwnerState = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<SettingsPaneRoot className={clsx(classes.root, className)}>
			{children.map((child, index) => (
				<SettingsPaneRow key={index} className={classes.row}>
					{child[0]}
					{child[1]}
				</SettingsPaneRow>
			))}
		</SettingsPaneRoot>
	);
};

export const SettingsPane = SettingsPanePrimitive;

export default SettingsPane;
